import { createRoot } from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import { initErrorTracking } from "./services/errorTracking";
import App from "./App.tsx";
import "./index.css";

// Initialize error tracking before React renders
initErrorTracking();

// Tell Capgo the app loaded successfully (native only)
if (Capacitor.isNativePlatform()) {
  import("@capgo/capacitor-updater")
    .then(({ CapacitorUpdater }) => CapacitorUpdater.notifyAppReady())
    .catch(() => {});
}

createRoot(document.getElementById("root")!).render(<App />);
